export const CHANGE_SURVEY_STATUS = 'CHANGE_SURVEY_STATUS';
